import type { TextPart } from "@iltocat/shared";

/**
 * Text with the searched-for words marked.
 *
 * Every part is rendered as a React text node, never as markup: what is in a
 * result is whatever somebody once typed into a notes box, and the worker sends
 * parts precisely so that nothing here can be turned into HTML.
 */
export function Highlight({ parts }: { parts: TextPart[] }) {
  return (
    <>
      {parts.map((part, index) =>
        part.hit ? <mark key={index}>{part.text}</mark> : <span key={index}>{part.text}</span>,
      )}
    </>
  );
}
